import React from 'react';
import { ContentTemplate, HeaderTemplate, KeyValue, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { selectCandidateResitRegistration } from '../../store/resitSlice';
import ResitEmailSuccess from '../../modules/resit/components/@coordinator/ResitEmailSuccess';

const CoordinatorResitEmailSuccessPage = () => {
  const { t } = useTranslation();
  const examRedux = useSelector(selectCandidateResitRegistration);

  return (
    <>
      <TitleHeader
        title={t('resit-->CoordinatorResit.Thank you. Emails have been sent to the candidate(s).')}
        state="success"
      />
      <HeaderTemplate>
        <KeyValue
          keyText={t('resit-->CoordinatorResit.Examination')}
          valueText={`${examRedux.examLevel?.description || ''} ${dayjs().year()}`}
        />
      </HeaderTemplate>

      <ContentTemplate continuous transparent>
        <ResitEmailSuccess />
      </ContentTemplate>
    </>
  );
};

export default CoordinatorResitEmailSuccessPage;
